import { translateSeriesName } from "@/common/utils/seriesNameTranslator";
import { DashboardComponentChartProps } from "@/features/company/types/dashboards/dashboardComponent.type";
import { numberTickFormatter } from "@/features/company/utils/dashboards/numberTickFormatter";
import { Fragment } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartTooltip } from "./components/ChartTooltip";

const LineChartComponent = ({
  chartData,
}: DashboardComponentChartProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={chartData?.data}
        margin={{
          top: 10,
          bottom: 10,
          left: 15,
          right: 20,
        }}
      >
        <CartesianGrid
          strokeWidth={1}
          opacity={0.1}
          horizontal={true}
          vertical={false}
        />

        <YAxis
          width="auto"
          style={{ fontSize: 11 }}
          tickFormatter={numberTickFormatter}
        />

        <Tooltip
          cursor={{ fill: '#ffffff', opacity: 0.08 }}
          content={<ChartTooltip chartData={chartData} />}
        />

        <XAxis
          style={{ fontSize: 11 }}
          dataKey={chartData?.primary_settings?.query_identifier}
        />

        {chartData?.series_settings && Object.entries(chartData?.series_settings).map(([key, value]) => (
          <Fragment key={key}>
            <Line
              dataKey={key}
              fill={value.color + '33'}
              stroke={value.color}
              isAnimationActive
              type="monotone"
              fillOpacity={1}
              strokeWidth={2}
              dot={false}
              connectNulls={true}
            />

            <Legend
              iconType="plainline"
              iconSize={12}
              wrapperStyle={{ fontSize: 11 }}
              labelStyle={{ color: '#ffffffaa' }}
              layout="horizontal"
              align="center"
              verticalAlign="bottom"
              formatter={translateSeriesName}
            />
          </Fragment>
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}

export default LineChartComponent;
